import { NativeTwilioAdapter } from './NativeTwilioAdapter';
import { WebTwilioAdapter } from './WebTwilioAdapter';

export function createTwilioAdapter(mobile) {
    const isMobile = !!mobile?.isMobile;

    if (isMobile) {
        return new NativeTwilioAdapter(mobile);
    }

    return new WebTwilioAdapter();
}
